import { MotionConfig } from 'motion/react';
/**
 * Minimal provider stack for the public pages.
 *
 * This is a stripped-down version of Provider.tsx. Nothing here may assume a signed-in user:
 * the OIDC provider wraps only the login and logout routes (see PublicApp). Keep it small:
 * every login loads it, so a page that needs more brings its own providers.
 */
import { BrowserRouter } from 'react-router-dom';

import { BrandProvider } from '@bedc/client/branding/providers';

import { SentryProvider } from '../providers/SentryProvider';
import { ToastProvider } from '../providers/ToastProvider';

export const PublicProvider = ({ children }: { children: React.ReactNode }) => {
	return (
		<BrandProvider>
			<SentryProvider>
				<MotionConfig
					reducedMotion="user"
					transition={{
						type: 'spring',
						stiffness: 1500,
						damping: 80,
					}}
				>
					<ToastProvider>
						<BrowserRouter>{children}</BrowserRouter>
					</ToastProvider>
				</MotionConfig>
			</SentryProvider>
		</BrandProvider>
	);
};
